var _rect, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg2 = function Svg2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_164_3236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_164_3236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00432 7.99961C8.33529 7.99961 8.61745 7.88176 8.85078 7.64608C9.08412 7.41038 9.20078 7.12704 9.20078 6.79608C9.20078 6.4651 9.08294 6.18294 8.84725 5.94961C8.61155 5.71628 8.32822 5.59961 7.99725 5.59961C7.66627 5.59961 7.38412 5.71745 7.15078 5.95314C6.91745 6.18884 6.80078 6.47218 6.80078 6.80314C6.80078 7.13412 6.91863 7.41628 7.15432 7.64961C7.39002 7.88294 7.67335 7.99961 8.00432 7.99961ZM8.00078 12.8163C9.323 11.6274 10.3202 10.5329 10.9924 9.53294C11.6647 8.53294 12.0008 7.6385 12.0008 6.84961C12.0008 5.68294 11.6202 4.71628 10.8591 3.94961C10.098 3.18294 9.14523 2.79961 8.00078 2.79961C6.85634 2.79961 5.90356 3.18294 5.14245 3.94961C4.38134 4.71628 4.00078 5.68294 4.00078 6.84961C4.00078 7.6385 4.33689 8.53294 5.00911 9.53294C5.68134 10.5329 6.67856 11.6274 8.00078 12.8163ZM8.00078 14.3996C6.25662 12.9429 4.9539 11.5898 4.09265 10.3404C3.2314 9.09098 2.80078 7.92739 2.80078 6.84961C2.80078 5.36072 3.29523 4.1135 4.28411 3.10794C5.273 2.10239 6.50912 1.59961 7.99245 1.59961C9.47578 1.59961 10.7147 2.10239 11.7091 3.10794C12.7036 4.1135 13.2008 5.36072 13.2008 6.84961C13.2008 7.92739 12.773 9.0885 11.9174 10.3329C11.0619 11.5774 9.75634 12.9329 8.00078 14.3996Z",
    fill: "#737382"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2.0b1e35b2.svg";
export { ForwardRef as ReactComponent };